export enum ButtonVariant {
	PRIMARY = "primary",
	SECONDARY = "secondary",
	OUTLINE_DARK = "outline-dark",
	OUTLINE_LIGHT = "outline-light",
	DESTRUCTIVE = "destructive",
	NAVY = "navy",
	GRAY_SECONDARY = "gray-secondary",
	WHITE_BORDERLESS = "white-borderless",
	FILTER_SQUARE = "filter-square",
	FILTER_ROUND = "filter-round",
}

export enum ButtonSizes {
	SMALL = "small",
	LARGE = "large",
}
